import * as React from "react"

import { cn } from "@/lib/utils"

// Tipos donde el corrector ortográfico nativo no aporta valor
const NO_SPELLCHECK_TYPES = new Set([
  "password", "email", "number", "tel", "url", "search",
  "date", "datetime-local", "time", "month", "week",
  "color", "file", "hidden", "checkbox", "radio", "range", "submit", "button", "reset",
])

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, spellCheck, lang, autoCorrect, autoCapitalize, ...props }, ref) => {
    const shouldSpellCheck = !NO_SPELLCHECK_TYPES.has(type ?? "text")
    return (
      <input
        type={type}
        spellCheck={spellCheck ?? shouldSpellCheck}
        lang={lang ?? (shouldSpellCheck ? "es" : undefined)}
        autoCorrect={autoCorrect ?? (shouldSpellCheck ? "on" : "off")}
        autoCapitalize={autoCapitalize ?? (shouldSpellCheck ? "sentences" : "off")}
        translate={shouldSpellCheck ? "yes" : undefined}
        className={cn(
          "flex h-10 w-full rounded-md border border-border/30 px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-0 focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50 md:text-sm transition-all duration-200",
          "bg-[hsl(var(--input-background))]",
          "focus-visible:shadow-[0_0_20px_hsl(217_91%_60%_/_0.3)]",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
